/* Chase USA — Shopify theme interactions */
(function () {
  'use strict';

  /* ---------- Mobile slide-out menu ---------- */
  var menu = document.querySelector('[data-ch-menu]');
  if (menu) {
    var openBtns = document.querySelectorAll('[data-ch-menu-open]');
    function menuOpen() {
      menu.classList.remove('is-hidden');
      requestAnimationFrame(function () { requestAnimationFrame(function () { menu.classList.add('is-open'); }); });
      document.body.style.overflow = 'hidden';
    }
    function menuClose() {
      menu.classList.remove('is-open');
      document.body.style.overflow = '';
      setTimeout(function () { menu.classList.add('is-hidden'); }, 250);
    }
    openBtns.forEach(function (b) { b.addEventListener('click', menuOpen); });
    menu.querySelectorAll('[data-ch-menu-close]').forEach(function (el) { el.addEventListener('click', menuClose); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !menu.classList.contains('is-hidden')) menuClose(); });
  }

  /* ---------- Live search overlay (Shopify predictive search) ---------- */
  var search = document.querySelector('[data-ch-search]');
  if (search) {
    var sOpen = document.querySelectorAll('[data-ch-search-open]');
    var sInput = search.querySelector('[data-ch-search-input]');
    var sResults = search.querySelector('[data-ch-search-results]');
    var sTimer = null, sCtrl = null;
    function searchOpen() {
      search.classList.remove('is-hidden');
      requestAnimationFrame(function () { requestAnimationFrame(function () { search.classList.add('is-open'); }); });
      document.body.style.overflow = 'hidden';
      if (sInput) setTimeout(function () { sInput.focus(); }, 60);
    }
    function searchClose() {
      search.classList.remove('is-open');
      document.body.style.overflow = '';
      setTimeout(function () { search.classList.add('is-hidden'); }, 220);
    }
    sOpen.forEach(function (b) { b.addEventListener('click', searchOpen); });
    search.querySelectorAll('[data-ch-search-close]').forEach(function (el) { el.addEventListener('click', searchClose); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !search.classList.contains('is-hidden')) searchClose(); });

    function msg(t) { sResults.innerHTML = '<div class="ch-search__msg">' + t + '</div>'; }
    function run(q) {
      q = (q || '').trim();
      if (sCtrl) { sCtrl.abort(); sCtrl = null; }
      if (q.length < 2) { sResults.innerHTML = ''; return; }
      sCtrl = ('AbortController' in window) ? new AbortController() : null;
      var url = '/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
      fetch(url, sCtrl ? { signal: sCtrl.signal } : {})
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          var items = data && data.resources && data.resources.results && data.resources.results.products || [];
          if (!items.length) { msg('No products found.'); return; }
          var html = '';
          items.forEach(function (p) {
            var img = p.image ? '<img src="' + p.image + '" alt="" loading="lazy">' : '';
            html += '<a class="ch-search__item" href="' + p.url + '">' + img + '<span>' + p.title + '</span></a>';
          });
          html += '<a class="ch-search__all" href="/search?q=' + encodeURIComponent(q) + '&type=product">See all results</a>';
          sResults.innerHTML = html;
        })
        .catch(function (err) { if (err && err.name === 'AbortError') return; msg('Press Enter to search.'); });
    }
    if (sInput) sInput.addEventListener('input', function () { clearTimeout(sTimer); var v = sInput.value; sTimer = setTimeout(function () { run(v); }, 220); });
  }

  /* ---------- Product gallery: thumbs, hover-zoom, color hover ---------- */
  document.querySelectorAll('[data-ch-gallery]').forEach(function (g) {
    var main = g.querySelector('[data-ch-main-img]');
    if (!main) return;
    main.dataset.current = main.getAttribute('src');
    function stick(src) { if (src) { main.dataset.current = src; main.src = src; } }
    function preview(src) { if (src) main.src = src; }
    function restore() { if (main.dataset.current) main.src = main.dataset.current; }

    g.querySelectorAll('[data-ch-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        g.querySelectorAll('[data-ch-thumb]').forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
        stick(t.getAttribute('data-full'));
      });
      t.addEventListener('mouseenter', function () { preview(t.getAttribute('data-full')); });
      t.addEventListener('mouseleave', restore);
    });

    // hover-to-zoom
    var frame = g.querySelector('[data-ch-zoom]');
    if (frame && (!window.matchMedia || window.matchMedia('(hover: hover) and (pointer: fine)').matches)) {
      frame.addEventListener('mouseenter', function () { main.style.transform = 'scale(2.2)'; });
      frame.addEventListener('mousemove', function (e) {
        var r = frame.getBoundingClientRect();
        var x = Math.min(100, Math.max(0, (e.clientX - r.left) / r.width * 100));
        var y = Math.min(100, Math.max(0, (e.clientY - r.top) / r.height * 100));
        main.style.transformOrigin = x + '% ' + y + '%';
      });
      frame.addEventListener('mouseleave', function () { main.style.transform = ''; main.style.transformOrigin = 'center center'; });
    }

    // color swatch hover preview (product page)
    g.closest('[data-ch-pdp]') && g.closest('[data-ch-pdp]').querySelectorAll('[data-ch-color][data-img]').forEach(function (sw) {
      sw.addEventListener('mouseenter', function () { preview(sw.getAttribute('data-img')); });
      sw.addEventListener('mouseleave', restore);
    });
  });

  /* ---------- Collection card: hover a color dot to swap the card image ---------- */
  document.querySelectorAll('[data-ch-card]').forEach(function (card) {
    var img = card.querySelector('[data-ch-card-img]');
    if (!img) return;
    var orig = img.getAttribute('src');
    card.querySelectorAll('[data-ch-card-dot][data-img]').forEach(function (dot) {
      dot.addEventListener('mouseenter', function () { img.src = dot.getAttribute('data-img'); });
      dot.addEventListener('mouseleave', function () { img.src = orig; });
    });
  });

  /* ---------- Case-pack quantity: snap manual entry to whole cases ---------- */
  document.querySelectorAll('[data-ch-qty]').forEach(function (qty) {
    var step = parseInt(qty.getAttribute('step'), 10) || 1;
    var min = parseInt(qty.getAttribute('min'), 10) || step;
    function snap() {
      var v = parseInt(qty.value, 10);
      if (isNaN(v) || v < min) { qty.value = min; return; }
      var cases = Math.round(v / step);
      if (cases < 1) { cases = 1; }
      qty.value = cases * step;
    }
    qty.addEventListener('change', snap);
    qty.addEventListener('blur', snap);
  });
})();
